import { TimelineMax, TweenMax, Power2, Power4, Back, Elastic } from "gsap/TweenMax";



export default class Animate {

    constructor() {

        this.bind();
    }




    triggerAnimate(data) {
        const el = data.detail;

        if (el.dataset.aos === 'animate') {
            data.type === 'aos:in' ? this.animate(el) : this.hide(el);
        }
    }




    animate(el, delay = 0.1, quick = false) {

        const time = !quick ? 1 : 0;

        switch(el.dataset.animate) {

            case 'graph-A':
                const graphA    = el.querySelector('.js-graph-shape');
                const textA     = el.querySelector('.js-graph-text');
                const bkgPathA  = graphA.querySelector('.js-bkg-path');
                const dataPathA = graphA.querySelector('.js-data-path');
                const dpLengthA = dataPathA.getTotalLength() + 5;

                const tlA = new TimelineMax({ delay: delay });

                tlA.set(dataPathA, { 'stroke-dasharray': dpLengthA, 'stroke-dashoffset': dpLengthA, })
                    .set(bkgPathA, { opacity: 0 })
                    .set(textA, { opacity: 0, scale: 1.1 })
                    .set(el, { opacity: 1 })
                    .addLabel('start')
                    .to(bkgPathA, time, {
                        opacity: 1,
                    })
                    .to(dataPathA, time, {
                        'stroke-dashoffset': 0,
                        ease: Power4.easeOut,
                        delay: time*0.25
                    }, 'start')
                    .to(textA, time, {
                        scale: 1,
                        opacity: 1,
                        ease: Power4.easeOut,
                        delay: time*0.5
                    }, 'start');
                break;

            case 'graph-B':
                const graphB    = el.querySelector('.js-graph-shape');
                const textB     = el.querySelector('.js-graph-text');
                const bkgPathB  = graphB.querySelector('.js-bkg-path');
                const dataPathB = graphB.querySelector('.js-data-path');

                const tlB = new TimelineMax({ delay: delay });

                tlB.set(dataPathB, { scale: 0.5, opacity: 0, transformOrigin: 'center center' })
                    .set(bkgPathB, { scale: 1.25, opacity: 0, transformOrigin: 'center center' })
                    .set(textB, { opacity: 0, scale: 1.1 })
                    .set(el, { opacity: 1 })
                    .addLabel('start')
                    .to(bkgPathB, time, {
                        scale: 1,
                        opacity: 1,
                        ease: Power4.easeOut,
                    })
                    .to(dataPathB, time*1.5, {
                        scale: 1,
                        opacity: 1,
                        ease: Elastic.easeOut,
                        delay: time*0.1
                    }, 'start')
                    .to(textB, time, {
                        scale: 1,
                        opacity: 1,
                        ease: Power4.easeOut,
                        delay: time*0.25
                    }, 'start');
                break;

            case 'graph-C':
                const graphC   = el.querySelector('.js-graph-shape');
                const textC    = el.querySelector('.js-graph-text');
                const pathC    = graphC.querySelector('.js-path');
                const dotC     = graphC.querySelector('.js-dot');
                const pLengthC = pathC.getTotalLength() + 5;

                const tlC = new TimelineMax({ delay: delay });

                tlC.set(pathC, { 'stroke-dasharray': pLengthC, 'stroke-dashoffset': pLengthC })
                    .set(dotC, { scale: 0, transformOrigin: 'center center' })
                    .set(textC, { opacity: 0, scale: 1.1 })
                    .set(graphC, { rotation: 0 })
                    .set(el, { opacity: 1 })
                    .addLabel('start')
                    .to(graphC, time*2, {
                        rotation: -720,
                        ease: Back.easeOut,
                    })
                    .to(dotC, time*2, {
                        scale: 1,
                        opacity: 1,
                        ease: Elastic.easeOut,
                    }, 'start')
                    .to(pathC, time*2, {
                        'stroke-dashoffset': 0,
                        ease: Power4.easeOut,
                        delay: time*0.1
                    }, 'start')
                    .to(textC, time, {
                        scale: 1,
                        opacity: 1,
                        ease: Power4.easeOut,
                        delay: time*0.25
                    }, 'start');
                break;

            case 'mission-A':
                this.graphMissionA(el, time, delay);
                break;

            case 'mission-B':
                this.graphMissionB(el, time, delay);
                break;

            case 'mission-C':
                this.graphMissionC(el, time, delay);
                break;

            case 'mission-D':
                this.graphMissionD(el, time, delay);
                break;

            case 'mission-E':
                this.graphMissionE(el, time, delay);
                break;

            default:
                console.warn(`animation type "${el.dataset.animate}" does not exist`);
                break;
        }
    }




    hide(el, quick = false) {

        const time = !quick ? 0.2 : 0;

        TweenMax.killChildTweensOf(el);
        TweenMax.to(el, time, {
            opacity: 0,
            clearProps: 'all'
        });
    }




    graphMissionA(el, time, delay) {
        const graph    = el.querySelector('.js-graph-shape');
        const dotsGrey = graph.querySelector('.js-graph-dots-grey');
        const dotsBlue = graph.querySelectorAll('.js-graph-dot-blue');

        const tl = new TimelineMax({ delay: delay });

        tl.set(dotsGrey, { opacity: 0 })
            .set(dotsBlue, { scale: 0, transformOrigin: 'center center' })
            .set(el, { opacity: 1 })
            .addLabel('start')
            .to(dotsGrey, time, {
                opacity: 1
            })
            .staggerTo(dotsBlue, time * 0.75, {
                scale: 1,
                ease: Elastic.easeOut,
            }, time * 0.1, 'start');
    }




    graphMissionB(el, time, delay) {
        const graph     = el.querySelector('.js-graph-shape');
        const dotsGrey  = graph.querySelector('.js-graph-dots-grey');
        const dotBlue   = graph.querySelector('.js-graph-dot-blue-centre');
        const dotsBlue1 = graph.querySelectorAll('.js-graph-dot-blue1');
        const dotsBlue2 = graph.querySelectorAll('.js-graph-dot-blue2');
        const dotsBlue3 = graph.querySelectorAll('.js-graph-dot-blue3');
        const dotsBlue4 = graph.querySelectorAll('.js-graph-dot-blue4');

        const tl = new TimelineMax({ delay: delay });

        tl.set(dotsGrey, { opacity: 0 })
            .set([dotBlue, dotsBlue1, dotsBlue2, dotsBlue3, dotsBlue4], { scale: 0, transformOrigin: 'center center' })
            .set(el, { opacity: 1 })
            .addLabel('start')
            .to(dotsGrey, time, {
                opacity: 1
            })
            .to(dotBlue, time * 0.75, {
                scale: 1,
                ease: Back.easeOut,
            }, 'start')
            .staggerTo(dotsBlue1, time * 0.5, {
                scale: 1,
                ease: Back.easeOut,
            }, (time * 0.1), 'start')
            .staggerTo(dotsBlue2, time * 0.5, {
                scale: 1,
                ease: Back.easeOut,
            }, (time * -0.1), `start+=${time * 0.25}`)
            .staggerTo(dotsBlue3, time * 0.5, {
                scale: 1,
                ease: Back.easeOut,
            }, (time * 0.1), `start+=${time * 0.5}`)
            .staggerTo(dotsBlue4, time * 0.5, {
                scale: 1,
                ease: Back.easeOut,
            }, (time * -0.1), `start+=${time * 0.75}`);
    }




    graphMissionC(el, time, delay) {
        const graph         = el.querySelector('.js-graph-shape');
        const dotsGrey      = graph.querySelector('.js-graph-dots-grey');
        const dotsBlueLevel = graph.querySelectorAll('.js-graph-dots-level');
        const dotsBlueRows  = graph.querySelectorAll('.js-graph-dot-blue-row');

        const tl = new TimelineMax({ delay: delay });

        tl.set([dotsGrey, dotsBlueRows, dotsBlueLevel], { opacity: 0 })
            .set(el, { opacity: 1 })
            .addLabel('start')
            .to(dotsGrey, time, {
                opacity: 1
            })
            .to(dotsBlueRows, time * 0.75, {
                opacity: 1
            }, `-=${time * 0.5}`)
            .addLabel('mid')
            .to(dotsBlueLevel, time * 0.1, {
                opacity: 1
            })
            .staggerTo(dotsBlueRows, time * 0.75, {
                opacity: 0
            }, time * -0.15, 'mid');
    }




    graphMissionD(el, time, delay) {
        const graph     = el.querySelector('.js-graph-shape');
        const dotsGrey  = graph.querySelector('.js-graph-dots-grey');
        const dotsBlue  = graph.querySelectorAll('.js-graph-dot-blue');

        const tl = new TimelineMax({ delay: delay });

        tl.set(dotsGrey, { opacity: 0 })
            .set(dotsBlue, { scale: 0, transformOrigin: 'center center' })
            .set(el, { opacity: 1 })
            .addLabel('start')
            .to(dotsGrey, time, {
                opacity: 1
            })
            .staggerTo(dotsBlue, time * 0.75, {
                scale: 1,
                ease: Back.easeOut,
            }, time * 0.1, 'start');
    }




    graphMissionE(el, time, delay) {
        const graph     = el.querySelector('.js-graph-shape');
        const elsGrey   = graph.querySelector('.js-graph-els-grey');
        const dotBlue   = graph.querySelector('.js-graph-dot-blue-centre');
        const ringsBlue = graph.querySelectorAll('.js-graph-ring-blue');

        const tl = new TimelineMax({ delay: delay });

        tl.set([elsGrey, ringsBlue], { opacity: 0 })
            .set(dotBlue, { scale: 0, transformOrigin: 'center center' })
            .set(el, { opacity: 1 })
            .addLabel('start')
            .to(elsGrey, time, {
                opacity: 1
            })
            .to(dotBlue, time * 0.75, {
                scale: 1,
                ease: Back.easeOut,
            }, `start+=${time * 0.2}`)
            .staggerTo(ringsBlue, time, {
                opacity: 1
            }, time * 0.25, `start+=${time * 0.3}`);
    }




    bind() {
        document.addEventListener('aos:in', (e) => this.triggerAnimate(e));
        document.addEventListener('aos:out', (e) => this.triggerAnimate(e));
    }
}


// WEBPACK FOOTER //
// ./src/js/animate.js